import useTranslation from '@/utils/hooks/translation/useTranslation';

import { ModalUpsell } from '@/components/composite/Modals/ModalUpsell';

export const DirectMessagesUpsellModal = ({ isOpen, toggle }) => {
    const { t } = useTranslation('commons');

    if (!isOpen) return null;

    return (
        <ModalUpsell
            heading={t('upsell_modal.direct_messages.heading')}
            description={t('upsell_modal.direct_messages.description')}
            benefits={[
                { text: t('upsell_modal.direct_messages.benefit1'), icon: 'check' },
                { text: t('upsell_modal.direct_messages.benefit2'), icon: 'check' },
                { text: t('upsell_modal.direct_messages.benefit3'), icon: 'check' },
                { text: t('upsell_modal.direct_messages.benefit4'), icon: 'plus' }
            ]}
            illustrationPath="/images/modals/modalUpsell/mention.png"
            dismiss={toggle}
            icon="rocket-outline"
        />
    );
};
